import { render } from "./DomesticGoodsPlacePageList.vue?vue&type=template&id=ba8c44cc&scoped=true&ts=true"
import script from "./DomesticGoodsPlacePageList.vue?vue&type=script&lang=ts"
export * from "./DomesticGoodsPlacePageList.vue?vue&type=script&lang=ts"

import "./DomesticGoodsPlacePageList.vue?vue&type=style&index=0&id=ba8c44cc&lang=sass&scoped=true"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba8c44cc"]])

export default __exports__